import { useUpdate } from "../../hooks/useUpdate";

export const UpdateOption = async (data, id) => {
  try {
    return await useUpdate(
      `${process.env.REACT_APP_API_URL}/options/${id}`,
      data
    );
  } catch (err) {
    console.log("ERROR: ", err.stack);
    return null;
  }
};
